import { systemConfigResourse, systemConfigFileList } from './request';
import contactWay from './components/contactWay.vue';
import clauseList from './components/clauseList.vue';
import bottomBarSet from './components/bottomBarSet.vue';
export default {
  name: 'settings',
  components: {
    contactWay,
    clauseList,
    bottomBarSet
  },
  data() {
    return {
      text: 111,
      activeKey: '1',
      datas: undefined,
      fileList: []
    };
  },
  mounted() {},
  methods: {
    async getSystemConfig() {
      let res = await systemConfigResourse({
        type: this.activeKey
      });
      this.datas = res;
    },
    tabChange(key) {
      console.log(key, 'tabChange key');
      this.activeKey = key;
      if (key !== '2') {
        this.getSystemConfig();
      }
      // if (key === '3') {
      //   // 获取文件列表
      //   this.getSystemConfigFileList();
      // }
    },
    // 获取文件列表
    async getSystemConfigFileList() {
      let res = await systemConfigFileList({
        language: this.language,
        page: 1,
        pageSize: 9999999
      });
      this.fileList = res.items;
    }
  }
};